export default {
  states: [{
    text: 'Activo',
    value: 1
  }, {
    text: 'Inactivo',
    value: 0
  }],
  emails: [{
    text: 'Por enviar',
    value: 0
  }, {
    text: 'A enviar',
    value: 1
  }, {
    text: 'Enviado',
    value: 2
  }, {
    text: 'Erro ao enviar',
    value: -1
    }],
  jobs: [{
      text: 'Pendente',
      value: 0
    }, {
      text: 'Em progresso',
      value: 1
    }, {
      text: 'Concluído',
      value: 2
    }, {
      text: 'Erro',
     value: -1
    }],
  isParent: [{
    text: 'Pais',
    value: 1
  }, {
    text: 'Filhos',
    value: 0
  }],
  isVeteran: [{
    text: 'V',
    value: 1
  }, {
    text: 'C',
    value: 0
  }],
  genders: [{
    text: 'Masculino',
    value: 1
  }, {
    text: 'Feminino',
    value: 2
  }],
  memberStates: [{
    text: 'Activo',
    value: 1
  }, {
    text: 'Inactivo',
    value: 0
  }, {
    text: 'Falecido',
    value: 2
  }],
  yesNo: [{
    text: 'Sim',
    value: 1
  }, {
    text: 'Não',
    value: 0
  }],
  historyStates: [
  {
    text: 'Participou',
    value: 1
  }, {
    text: 'Não teve lugar',
    value: 0
  }, {
    text: 'Desistiu',
    value: -1
  }, {
    text: 'Desistiu Sem Penalização',
    value: -4
  }],
  feeStates: [
  {
    text: 'Pago',
    value: 1
  }, {
    text: 'Por pagar',
    value: 0
  }, {
    text: 'Fora do prazo',
    value: 2
  }],
  referenceStates: [
  {
    text: 'Pago',
    value: 1
  }, {
    text: 'Por pagar',
    value: 0
  }, {
    text: 'Cancelada',
    value: -1
  }],
  registrationStates: [
  {
    text: 'Confirmado',
    value: 1
  }, {
    text: 'Confirmado - Subsidio',
    value: 2
  }, {
    text: 'Pendente',
    value: 0
  }, {
    text: 'Desistiu',
    value: -1
  }, {
    text: 'Desistiu Sem Penalização',
    value: -4
    // }, {
    //   text: 'Desistiu - Pagamento',
    //   value: -2
    // }, {
    //   text: 'Desistiu - Admin',
    //   value: -3
  }],
  familyMemberTypes: [{
    text: 'Pais',
    value: 1
  }, {
    text: 'Filhos',
    value: 2
  }],
  months: [{
    text: 'Jan',
    value: 1
  }, {
    text: 'Fev',
    value: 2
  }, {
    text: 'Mar',
    value: 3
  }, {
    text: 'Abr',
    value: 4
  }, {
    text: 'Mai',
    value: 5
  }, {
    text: 'Jun',
    value: 6
  }, {
    text: 'Jul',
    value: 7
  }, {
    text: 'Ago',
    value: 8
  }, {
    text: 'Set',
    value: 9
  }, {
    text: 'Out',
    value: 10
  }, {
    text: 'Nov',
    value: 11
  }, {
    text: 'Dez',
    value: 12
    }],
  campaigns: {
    recipientTypes: [{
      text: 'Família',
      value: 1
    }, {
        text: 'Pessoas',
        value: 2
      }],
    recipientConditionsOperator: [{
      value: 'and',
      text: 'tem de cumprir <strong>todas</strong> as condições'
    }, {
      value: 'or',
      text: 'tem de cumprir <strong>uma</strong> das condições'
    }],
    states: [{
      text: 'Por enviar',
      value: 0
    }, {
      text: 'A enviar',
      value: 1
    }, {
      text: 'Enviada',
      value: 2
    }]
  },
  translate: function(a, b) {
    for (let i = 0; i < this[b].length; i++) {
      if (this[b][i].value == a) {
        return this[b][i].text
      }
    }
    return a
  }
}
